import React from "react"

import NotificationContainer from "components/NotificationContainer"

import addStudentMutation from "./addStudentMutation"
import MatchedUsers from "./index"
import loadMatchedStudentsQuery from "./loadMatchedStudentsQuery"
import removeStudentMutation from "./removeStudentMutation"

const MatchedStudents = ({ tutorId }) => {
  return (
    <>
      <NotificationContainer />
      <MatchedUsers
        sourceUserId={tutorId}
        sourceKey="tutor"
        matchedKey="student"
        loadUsersQuery={loadMatchedStudentsQuery}
        matchUserMutation={addStudentMutation}
        unmatchUserMutation={removeStudentMutation}
        autocompletePath="/api/admins/students/autocomplete_full_name"
        searchAutocompletePath={`/api/admins/tutors/${tutorId}/autocomplete_recommended_students`}
      />
    </>
  )
}

export default MatchedStudents
